import { useMutation } from '@tanstack/react-query';
import useCustomInstance from 'api/mutator/custom-instance';
import { TranslateCommentResponse } from 'api/model';

interface TranslateExpenseParams {
  expenseId: number;
  targetLanguage?: string;
}

const useTranslateExpense = () => {
  const customInstance = useCustomInstance<TranslateCommentResponse>();

  return useMutation({
    mutationFn: ({ expenseId, targetLanguage = 'Swedish' }: TranslateExpenseParams) => {
      return customInstance({
        url: `/api/Expense/TranslateExpense`,
        method: 'POST',
        params: { expenseId, targetLanguage },
      });
    },
  });
};

export default useTranslateExpense;
